function ErrorMessageSign({ errMessage, className = "" }) {
    return (
      <span className={`msg_error_sign ${className}`}>{errMessage}</span>
  
    );
  }
  
  export default ErrorMessageSign;
  